var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"primary-blue-button-container"},[_c('button',{staticClass:"primary-blue-button-button button buttonSmall"},[_vm._v(" "+_vm._s(_vm.button)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }